import React, { memo } from 'react';

import { cn } from '@nextui-org/react';

interface IProps {
	className?: string;
}

const Divider: React.FC<IProps> = ({ className }) => {
	return <div className={cn('bg-silver h-px w-full', className)} />;
};

export default memo(Divider);
